import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-16 sm:py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="mx-auto text-[#B91C1C]" size={48} />
      <h1 className="mt-4 text-xl sm:text-2xl font-semibold text-brand-ink">Betaling annulleret</h1>
      <p className="mt-2 text-sm text-brand-body">Din forespørgsel er stadig åben. Du kan vælge en anden ekspert eller prøve igen.</p>
      <Link to="/dashboard" className="btn-primary mt-5 inline-block !py-2 text-sm" data-testid="cancel-back-btn">
        Tilbage til dashboard
      </Link>
    </div>
  );
}

